import { css, html, LitElement } from "lit";
import { neutral } from "../../../legl-ui/lds-colours";
import "../../../legl-ui/lds-icon";
import { spacing } from "../../../legl-ui/lds-spacing";
import { typographyPresets } from "../../../legl-ui/lds-typography";

export class LdsChip extends LitElement {
  static get styles() {
    return css`
            :host {
                display: inline-block;
                border-radius: 16px;
                ${typographyPresets.medium};
                padding: 4px 4px 4px 12px;
                background-color: ${neutral["200"]};
                color: ${neutral["800"]};
                margin-right: ${spacing["xs"]};
            }

            button {
                border-radius: 100%;
                border-color: transparent;
                margin-left: ${spacing["xxs"]};
                padding: 0px;
                background-color: transparent;
                color: ${neutral["800"]};
                display: flex;
            }

            button:hover {
                background-color: ${neutral["300"]};
                cursor: pointer;
            }

            legl-icon {
                display: flex;
                font-size: 14px;
            }

            .chip-container {
                display: flex;
                align-items: center;
            }
        `;
  }

  static get properties() {
    return {
      text: {
        attribute: true,
      },
      clickHandler: {
        attribute: false,
        type: Object,
      },
    };
  }

  render() {
    return html`<div class="chip-container">
            <span>${this.text}</span>
            <button
                aria-label=${this.text}
                @click=${() => this.clickHandler(this.text)}
            >
                <lds-icon small name="lds-icon-Close"></lds-icon>
            </button>
        </div>`;
  }
}

if (!customElements.get("lds-chip")) {
  customElements.define("lds-chip", LdsChip);
}
